export class TodoObject {
    constructor(todoText, doneDone) {
        this.todoText = todoText;
        this.doneDone = doneDone;
    }
}